import { Content } from '../types/content';

export const CONTENT_SORT_VALUES = {
  TITLE: 'title',
  DATE: 'date',
  DURATION: 'duration',
  VIEWS: 'views',
  COUNT: 'count',
  CREATED_AT: 'createdAt'
} as const;

export const CONTENT_TYPES = {
  VIDEO: 'Video',
  AUDIO: 'Audio',
  LIVE: 'Live'
} as const;

export const BROADCAST_STATUS = {
  LIVE: 'live',
  UPCOMING: 'upcoming',
  COMPLETED: 'completed'
} as const;

export const DURATION_RANGES = {
  SHORTS: '0-5',
  MEDIUM: '5-45',
  LONG: '45'
} as const;

export interface ContentTypeOption {
  id: string;
  labelKey: string;
  iconName: string;
  apiConfig: {
    endpoint: 'content' | 'lives' | 'topics';
    params?: Partial<Record<string, string>>;
  };
}

export const CONTENT_TYPE_OPTIONS: ContentTypeOption[] = [
  {
    id: 'videos',
    labelKey: 'content.types.videos',
    iconName: 'video',
    apiConfig: {
      endpoint: 'content',
      params: { type: CONTENT_TYPES.VIDEO }
    }
  },
  {
    id: 'shorts',
    labelKey: 'content.types.shorts',
    iconName: 'shorts',
    apiConfig: {
      endpoint: 'content',
      params: { 
        type: CONTENT_TYPES.VIDEO,
        duration: DURATION_RANGES.SHORTS 
      }
    }
  },
  {
    id: 'lives',
    labelKey: 'content.types.lives',
    iconName: 'live',
    apiConfig: {
      endpoint: 'lives'
    }
  },
  {
    id: 'audio',
    labelKey: 'content.types.audio',
    iconName: 'audio',
    apiConfig: {
      endpoint: 'content',
      params: { type: CONTENT_TYPES.AUDIO }
    }
  },
  {
    id: 'topics',
    labelKey: 'content.types.topics',
    iconName: 'topic',
    apiConfig: {
      endpoint: 'topics'
    }
  }
]; 